// extracted by css-extract-rspack-plugin
export default {"parameterGrid":"parameterGrid-yvJ9kR"};